module.exports = __webpack_public_path__ + "media/images/icons/twotone/unlock-fc2e4d367b4f956694264893b61f5adb.svg";